// What the Calls pages dispatch. The `LEGACY_*` half serves the v1 metrics API
// behind /calls-legacy; the rest serves the v3 call-api page.
const actions = {
  SET_STATE: 'calls/SET_STATE',
  GET_CALL_LOGS: 'calls/GET_CALL_LOGS',
  GET_CALL_BY_ID: 'calls/GET_CALL_BY_ID',
  DOWNLOAD_CALL_RECORDING: 'calls/DOWNLOAD_CALL_RECORDING',

  GET_LEGACY_CALL_LOGS: 'calls/GET_LEGACY_CALL_LOGS',
  GET_LEGACY_CALL_BY_ID: 'calls/GET_LEGACY_CALL_BY_ID',
  GET_LEGACY_CALL_PARTICIPANTS: 'calls/GET_LEGACY_CALL_PARTICIPANTS',
  DOWNLOAD_LEGACY_CALL_RECORDING: 'calls/DOWNLOAD_LEGACY_CALL_RECORDING',
}

export default actions
